// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"kW-z","sponsoredTooltipWrapper":"lW-z","sponsoredTooltip":"mW-z","newCard":"nW-z"};